import type { SpecialOffer } from '../types/menu'

export const specials: SpecialOffer[] = [
  {
    id: 'taco-tuesday',
    when: 'Every Tuesday',
    title: 'Taco Tuesday',
    price: '3 for $9',
    description: 'Any three street tacos — mix and match asada, pastor, chicken or chorizo.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7e0dac93-666f-48a6-bf02-73e3339e2e6f.jpg',
  },
  {
    id: 'lunch-combo',
    when: 'Weekdays 11am – 2pm',
    title: 'Burrito Lunch Combo',
    price: '$12',
    description: 'Any burrito with chips, house salsa and a fountain drink.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7b18cd79-a238-495c-81ba-35f1c8ae1b8a.jpg',
  },
  {
    id: 'birria-weekend',
    when: 'Fri & Sat only',
    title: 'Birria Weekend',
    price: '3 for $14',
    description: 'Cheesy crispy birria tacos with a cup of hot consommé for dipping.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/21fafac5-6c5b-44f6-a528-2cc06478a4bf.jpg',
  },
]
